module.exports = __webpack_public_path__ + "static/img/2902_phase_function_Paper_PointsHejduk_Prediction.29a3c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2902_phase_function_Paper_PointsHejduk_Prediction.png
// module id = xMq/
// module chunks = 0